<div class="eco-page">
  <header class="eco-header flex align-items-center gap-3">
    <button routerLink="/indicadores" class="bg-transparent border-none text-600 cursor-pointer p-2 border-round-circle hover:bg-teal-100 flex align-items-center">
      <span class="material-symbols-outlined line-height-1">arrow_back</span>
    </button>
    <div class="eco-brand-badge" style="width: 48px !important; height: 48px !important; min-width: 48px !important; min-height: 48px !important; max-width: 48px !important; max-height: 48px !important; padding: 6px !important; overflow: hidden !important; display: inline-flex !important; align-items: center !important; justify-content: center !important;">
      <img src="assets/ecodados-symbol.svg" alt="EcoDados Logo" style="width: 36px !important; height: 36px !important; max-width: 36px !important; max-height: 36px !important; object-fit: contain !important; display: block !important;">
    </div>
    <div>
      <h1 class="eco-title text-lg my-0">{{ isEdit ? 'Editar Indicador' : 'Novo Indicador' }}</h1>
      <p class="eco-label my-0 mt-0.5">Configuração de Métrica</p>
    </div>
  </header>

  <main class="eco-container flex flex-column gap-4">
    @if (error()) {
      <div class="p-3 bg-red-50 border-1 border-red-200 border-round-xl text-red-900 text-xs font-bold flex align-items-center gap-2">
        <span class="material-symbols-outlined text-red-600">error</span>
        <p class="my-0">{{ error() }}</p>
      </div>
    }

    @if (loadingIndicator()) {
      <div class="flex flex-column align-items-center justify-content-center py-6 gap-3">
        <div class="w-3rem h-3rem border-circle border-3 border-teal-200 border-t-teal-700 eco-spin"></div>
        <p class="text-sm text-600">Carregando indicador...</p>
      </div>
    } @else if (loadFailed()) {
      <div class="eco-card flex flex-column align-items-center gap-3 text-center py-5">
        <span class="material-symbols-outlined text-4xl text-500">search_off</span>
        <p class="text-sm text-700 my-0">Não foi possível carregar este indicador.</p>
        <p-button label="Voltar aos indicadores" icon="pi pi-arrow-left" severity="secondary" [outlined]="true" routerLink="/indicadores" />
      </div>
    } @else {
    <div class="grid">
      <!-- Form Section -->
      <section class="col-12 lg:col-8">
        <div class="eco-card flex flex-column gap-4">
          <div class="grid">
            <div class="col-12 md:col-6 flex flex-column gap-1">
              <label class="eco-label">Sigla / Código</label>
              <input [(ngModel)]="form().sigla" placeholder="Ex: CPP" class="eco-input">
            </div>
            
            <div class="col-12 md:col-6 flex flex-column gap-1">
              <label class="eco-label">Unidade de Medida</label>
              <input [(ngModel)]="form().unidade_medida" placeholder="Ex: kWh, R$, Resmas" class="eco-input">
            </div>
          </div>

          <div class="flex flex-column gap-1">
            <label class="eco-label">Nome Completo</label>
            <input [(ngModel)]="form().nome" placeholder="Ex: Consumo de papel pardo próprio" class="eco-input">
          </div>

          <div class="eco-card-low flex align-items-center justify-content-between p-3 border-round-xl">
            <div>
              <span class="eco-label block mb-1">Status do indicador</span>
              <label for="indicatorActive" class="text-sm font-bold text-800">Ativo</label>
            </div>
            <div class="flex align-items-center gap-3">
              <span class="text-xs font-bold px-3 py-1 border-round-md"
                [style.color]="form().ativo ? 'var(--eco-primary)' : 'var(--eco-text-muted)'"
                [style.background-color]="form().ativo ? 'var(--eco-primary-container)' : 'var(--eco-surface-high)'">
                {{ form().ativo ? 'Ativo' : 'Inativo' }}
              </span>
              <p-toggleswitch inputId="indicatorActive" [ngModel]="form().ativo" (ngModelChange)="updateAtivo($event)" />
            </div>
          </div>

          <div class="eco-card-low flex flex-column gap-2">
            <label id="periodicityLabel" class="eco-label">Periodicidade da coleta</label>
            <p-selectbutton [options]="periodicidadeOptions" optionLabel="label" optionValue="value"
              [allowEmpty]="false" [ngModel]="form().periodicidade"
              (ngModelChange)="updatePeriodicidade($event)" ariaLabelledBy="periodicityLabel" />
            <p class="text-xs text-600 my-0">{{ form().periodicidade === 'ANUAL' ? 'Uma coleta será gerada a cada ano.' : 'Uma coleta será gerada a cada mês.' }}</p>
          </div>

          <div class="pt-3 border-t-1 border-teal-100 flex justify-content-end align-items-center">
            <p-button [label]="submitting() ? 'Salvando...' : (isEdit ? 'Salvar Alterações' : 'Salvar Indicador')" icon="pi pi-check" severity="primary" size="small" [rounded]="true" [disabled]="submitting()" [loading]="submitting()" (onClick)="requestSave()" />
          </div>
        </div>
      </section>

      <!-- Assignments Section -->
      <section class="col-12 lg:col-4">
        <div class="eco-card-low flex flex-column gap-3">
          <h2 class="eco-title text-base flex align-items-center gap-2 my-0">
            <span class="material-symbols-outlined text-teal-700">group</span>
            Responsáveis
          </h2>

          @if (isEdit) {
            <div class="flex flex-column gap-1">
              <div class="flex gap-2">
                <input [(ngModel)]="newResponsibleEmail" (keyup.enter)="addResponsible()" placeholder="e-mail institucional" class="eco-input flex-1">
                <p-button icon="pi pi-plus" severity="primary" size="small" (onClick)="addResponsible()" />
              </div>
              <p class="text-micro text-600 mt-1 mb-0">O usuário deve estar previamente cadastrado no sistema.</p>
            </div>

            <div class="flex flex-column gap-2">
              @for (resp of responsaveis(); track resp.id) {
                <div class="bg-white p-2 border-round-xl flex align-items-center justify-content-between border-1 border-teal-100">
                  <div class="overflow-hidden">
                    <p class="text-xs font-bold text-800 my-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ resp.email || resp.usuario_id }}</p>
                  </div>
                  <p-button icon="pi pi-times" severity="danger" [text]="true" [rounded]="true" size="small" (onClick)="removeResponsible(resp.id)" />
                </div>
              } @empty {
                <div class="text-center py-4 opacity-50 flex flex-column align-items-center">
                  <span class="material-symbols-outlined text-3xl">face</span>
                  <p class="eco-label mt-2 my-0">Ninguém vinculado</p>
                </div>
              }
            </div>
          } @else {
            <div class="bg-white border-1 border-dashed border-teal-200 border-round-xl p-4 text-center">
              <p class="text-xs text-600 my-0">Salve o indicador primeiro para poder vincular responsáveis.</p>
            </div>
          }
        </div>
      </section>
    </div>
    }
  </main>

  <!-- Confirmação ao salvar a inativação -->
  <p-dialog 
    header="Inativar indicador?" 
    [visible]="showInactivateConfirmation()" 
    [modal]="true" 
    [style]="{ width: '90vw', maxWidth: '460px' }" 
    [draggable]="false" 
    [resizable]="false" 
    (onHide)="showInactivateConfirmation.set(false)">
    
    <div class="flex flex-column gap-3 pt-2">
      <p class="text-sm text-600 line-height-3 my-0">
        O indicador deixará de receber novas coletas automáticas, mas suas coletas e dados históricos serão preservados.
      </p>

      <div class="flex justify-content-end gap-2 pt-2">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" size="small" (onClick)="showInactivateConfirmation.set(false)" />
        <p-button label="Inativar e salvar" icon="pi pi-check" severity="primary" size="small" [loading]="submitting()" (onClick)="confirmInactivateAndSave()" />
      </div>
    </div>
  </p-dialog>
</div>
